import { Box } from '@mantine/core';

import { useGetColor } from 'hooks';

import type { IconPropsType } from './types';

export const DocumentsIcon = ({
  color,
  size = 24,
  sx,
  ...props
}: IconPropsType) => {
  const iconColor = useGetColor(color);

  return (
    <Box
      component="svg"
      sx={sx}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.57143 11.9948H15.4286M8.57143 15.4286H15.4286M8.57143 8.56843H15.4286M17.7143 20H6.28571C5.65453 20 5.14286 19.4883 5.14286 18.8571V5.14286C5.14286 4.51168 5.65453 4 6.28571 4H15.4286L18.8571 7.42857V18.8571C18.8571 19.4883 18.3455 20 17.7143 20Z"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </Box>
  );
};
